export default {
  notificationTabs: [],
  notifications: {
    flags: [],
    order: [],
    PO: [],
    customerProof: []
  },
  rolesNotification: {},
  myOrders: false,
  testOrders: false
};
